var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import moment from 'moment';
import { Expose, Type, Transform } from 'class-transformer';
export class NotificationEndpointTemplateModel {
    template;
    templateName;
    templateType;
    type;
    createdAt;
    updatedAt;
}
__decorate([
    Expose({ name: 'notificationType' }),
    __metadata("design:type", String)
], NotificationEndpointTemplateModel.prototype, "type", void 0);
__decorate([
    Expose({ name: 'createdDate' }),
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], NotificationEndpointTemplateModel.prototype, "createdAt", void 0);
__decorate([
    Expose({ name: 'modifiedDate' }),
    Type(() => Date),
    Transform(value => moment(value * 1000), { toClassOnly: true }),
    Transform(value => value?.valueOf(), { toPlainOnly: true }),
    __metadata("design:type", Object)
], NotificationEndpointTemplateModel.prototype, "updatedAt", void 0);
//# sourceMappingURL=notification-endpoint-template.js.map